var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-legend"},[_c('div',{staticClass:"legend position-absolute p-2",class:{ 'text-white': !_vm.negativeText }},[_c('global-rich-text',{attrs:{"payload":_vm.legend}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }